var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        { staticClass: "mb-10", attrs: { align: "center" } },
        [
          _c(
            "v-col",
            [
              _c("span", [
                _vm._v(
                  "Список: (" + _vm._s(_vm.listItem.data.pills.length) + ")"
                ),
              ]),
              _c("ErrorMessage", {
                attrs: { message: _vm.errorMessages.pills },
              }),
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              staticClass: "mr-2",
              attrs: {
                small: "",
                disabled: _vm.isLoading,
                loading: _vm.isLoading,
              },
              on: {
                click: function ($event) {
                  return _vm.mixAddListItemItemHandler(
                    "pills",
                    _vm.$options.widgetItems
                  )
                },
              },
            },
            [_c("v-icon", { attrs: { small: "" } }, [_vm._v(" mdi-plus ")])],
            1
          ),
        ],
        1
      ),
      _vm._l(
        _vm.listItem.data.pills,
        function (listItemItem, listItemItemIndex) {
          return _c(
            "v-row",
            {
              key: listItemItemIndex,
              staticClass: "mb-5",
              attrs: { align: "center" },
            },
            [
              _c(
                "v-card",
                { attrs: { flat: "", color: "transparent" } },
                [
                  _c("v-card-title", [
                    _vm._v("Кнопка " + _vm._s(listItemItemIndex + 1) + ":"),
                  ]),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "span",
                                [
                                  _vm._v("Текст ("),
                                  _c("TranslationIcon"),
                                  _vm._v(")"),
                                ],
                                1
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  outlined: "",
                                  disabled: _vm.isLoading,
                                  loading: _vm.isLoading,
                                  value: listItemItem.data.title,
                                  "error-messages": _vm.errorMessages[
                                    listItemItemIndex
                                  ]
                                    ? _vm.errorMessages[listItemItemIndex].title
                                    : "",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.mixChangeListItemItemHandler(
                                      $event,
                                      "pills",
                                      listItemItemIndex,
                                      "title"
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "span",
                                [
                                  _vm._v("Подзаголовок ("),
                                  _c("TranslationIcon"),
                                  _vm._v(")"),
                                ],
                                1
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  outlined: "",
                                  disabled: _vm.isLoading,
                                  loading: _vm.isLoading,
                                  value: listItemItem.data.subTitle,
                                  "error-messages": _vm.errorMessages[
                                    listItemItemIndex
                                  ]
                                    ? _vm.errorMessages[listItemItemIndex]
                                        .subTitle
                                    : "",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.mixChangeListItemItemHandler(
                                      $event,
                                      "pills",
                                      listItemItemIndex,
                                      "subTitle"
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("span", [_vm._v("Код иконки")]),
                              _c("v-text-field", {
                                attrs: {
                                  outlined: "",
                                  disabled: _vm.isLoading,
                                  loading: _vm.isLoading,
                                  value: listItemItem.data.iconCode,
                                  "error-messages": _vm.errorMessages[
                                    listItemItemIndex
                                  ]
                                    ? _vm.errorMessages[listItemItemIndex]
                                        .iconCode
                                    : "",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.mixChangeListItemItemHandler(
                                      $event,
                                      "pills",
                                      listItemItemIndex,
                                      "iconCode"
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("span", [_vm._v("Ссылка")]),
                              _c("v-text-field", {
                                attrs: {
                                  outlined: "",
                                  disabled: _vm.isLoading,
                                  loading: _vm.isLoading,
                                  value: listItemItem.data.link,
                                  "error-messages": _vm.errorMessages[
                                    listItemItemIndex
                                  ]
                                    ? _vm.errorMessages[listItemItemIndex].link
                                    : "",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.mixChangeListItemItemHandler(
                                      $event,
                                      "pills",
                                      listItemItemIndex,
                                      "link"
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card",
                { attrs: { flat: "", color: "transparent" } },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            small: "",
                            disabled: _vm.isLoading,
                            loading: _vm.isLoading,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.mixRemoveListItemItemHandler(
                                listItemItemIndex,
                                "pills"
                              )
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { color: "red" } }, [
                            _vm._v("mdi-trash-can-outline"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        }
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }